import React from "react";
import background from "../../resources/images/BUBO/cemetery.jpg";

import { MintForm } from "../forms/MintForm";

export function Background(): React.ReactElement {

  return(
    <div className="background-wrapper">
      <img
        className="background-img"
        id="background-img"
        alt="background-img"
        src={background}
        style={{
          zIndex: 100,
        }}
      />
      <div id="foglayer_01" className="fog">
        <div className="image01"></div>
        <div className="image02"></div>
      </div>
      <div id="foglayer_02" className="fog">
        <div className="image01"></div>
        <div className="image02"></div>
      </div>
      <div id="foglayer_03" className="fog">
        <div className="image01"></div>
        <div className="image02"></div>
      </div>
      {/* <MintButton/> */}
      <MintForm/>
      {/* <WarningMessage/> */}
    </div>
  )
}
